/* eslint react/prop-types: 0 */
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import QIconButton from 'components/QIconButton';
import CloseIcon from '@mui/icons-material/Close';

const styles = ({ palette }) => ({
  closeIcon: {
    color: palette.text.tertiary,
  },
  closeBox: {
    position: 'absolute',
    right: '5px',
    top: '5px',
  },
});
const useStyles = makeStyles()(styles);

const QCloseBox = (props) => {

  const { onClose } = props;
  const { classes } = useStyles(props);

  return (
    <div className={classes.closeBox} {...(props.id ? { id: props.id } : {})}>
      <QIconButton
        size="small-target"
        onClick={onClose}
        IconProps={{ classes: { root: classes.closeIcon } }}
        IconComponent={CloseIcon}
      />
    </div>
  );
};

export default QCloseBox;
